if ($("header#header").length) {
  $('<span class="close"></span>').appendTo(".login-widget .popup-widget-inner #customerLogin");
  $('.top-navigation-contacts').prepend('<div class="status"></div>');
  
  $(".header-top").append($(".top-navigation-bar .responsive-tools").clone());
  $("body .header-top .responsive-tools").append($(".top-navigation-bar .top-navigation-contacts .project-phone").clone());
  $(".top-navigation-bar .top-navigation-contacts a.project-phone").each(function () {
    const $phone = $(this);
    const $number = $phone.find("span").first();
    const phoneNumber = $.trim($number.text());

    if ($number.length && /^\+420\s/.test(phoneNumber) && !$phone.find(".phone-prefix").length) {
      $number.text(phoneNumber.replace(/^\+420\s*/, ""));
      $('<span class="phone-prefix"></span>').text("+420").prependTo($phone);
    }
  });
  $(".search input").attr("placeholder", "Hledat produkty...");
  $(".top-navigation-contacts").append('<a class="cbtn ost" href="/kontakty/#showroom">Prodejna Ostrava</a>');
  $(".top-navigation-contacts").append('<a class="cbtn prg" href="/kontakty/#showroom">Prodejna Praha</a>');

  $("body:not(.mobile) .header-top .responsive-tools").prepend($(".top-navigation-tools .dropdown").clone());
  $("body.mobile .header-top .responsive-tools").prepend($(".top-navigation-tools .dropdown").clone());
  $(".header-top .site-name-wrapper").append($('<a class="simply" href="/" target="_blank" rel="noopener noreferrer"><img src="/user/documents/sablona/simply.svg" alt="Site Logo"></a>'));
  $('.header-top .site-name-wrapper').append('<div class="status"></div>')
  $('body.mobile a[data-target="cart"]').removeClass("toggle-window");
  $('.navigation-buttons a[data-target="cart"]').clone().appendTo(".header-top .responsive-tools");

  if (!$("#cart-widget .emptyCart").length) {
    $("#cart-widget").append($("#footer .emptyCart").clone());
  }
  $(".header-top .responsive-tools").append($(".header-top .site-name-wrapper").clone());

  $(document).ready(function () {
    const $cartHoverArea = $(".responsive-tools a[data-target='cart'], .responsive-tools .cart-count");
    const $cartWidget = $("#cart-widget");
    const $body = $("body");
    let cartCloseTimeout = null;
    let isHoveringCartTrigger = false;
    let isHoveringCartWidget = false;

    function isDesktopCartHoverEnabled() {
      return window.matchMedia("(min-width: 992px)").matches;
    }

    function clearCartCloseTimeout() {
      if (cartCloseTimeout) {
        clearTimeout(cartCloseTimeout);
        cartCloseTimeout = null;
      }
    }

    function isInCartInteractionArea(element) {
      if (!element) {
        return false;
      }
      return $(element).closest(".responsive-tools a[data-target='cart'], .responsive-tools .cart-count, #cart-widget").length > 0;
    }

    function scheduleCartClose() {
      clearCartCloseTimeout();
      cartCloseTimeout = setTimeout(closeCartWidget, 60);
    }

    function isCartAreaHovered() {
      return isHoveringCartTrigger || isHoveringCartWidget;
    }

    function keepCartVisibleClasses() {
      $body.addClass("user-action-visible cart-window-visible");
      $cartWidget.css("display", "block");
    }

    function openCartWidget() {
      clearCartCloseTimeout();
      shoptet.popups.showPopupWindow("cart", true);
      keepCartVisibleClasses();
    }

    function closeCartWidget() {
      clearCartCloseTimeout();
      if (isCartAreaHovered()) {
        return;
      }

      if (shoptet?.popups && typeof shoptet.popups.hidePopupWindow === "function") {
        shoptet.popups.hidePopupWindow("cart");
      }
      $body.removeClass("cart-window-visible");
      $cartWidget.css("display", "none");
    }

    if (document.body) {
      const cartBodyClassObserver = new MutationObserver(function (mutations) {
        if (!isDesktopCartHoverEnabled()) {
          return;
        }

        const classChanged = mutations.some(function (mutation) {
          return mutation.attributeName === "class";
        });

        if (!classChanged || !isCartAreaHovered()) {
          return;
        }

        if (!$body.hasClass("cart-window-visible") || !$body.hasClass("user-action-visible")) {
          keepCartVisibleClasses();
        }
      });

      cartBodyClassObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    $cartHoverArea.off("mouseenter.cartHover mouseleave.cartHover");
    $cartHoverArea.on("mouseenter.cartHover", function () {
      isHoveringCartTrigger = true;
      if (isDesktopCartHoverEnabled()) {
        openCartWidget();
      }
    });

    $cartHoverArea.on("mouseleave.cartHover", function (event) {
      isHoveringCartTrigger = false;
      if (isDesktopCartHoverEnabled()) {
        if (isInCartInteractionArea(event.relatedTarget)) {
          clearCartCloseTimeout();
          return;
        }
        scheduleCartClose();
      }
    });

    $cartWidget.off("mouseenter.cartHover mouseleave.cartHover");
    $cartWidget.on("mouseenter.cartHover", function () {
      isHoveringCartWidget = true;
      if (isDesktopCartHoverEnabled()) {
        clearCartCloseTimeout();
        keepCartVisibleClasses();
      }
    });

    $cartWidget.on("mouseleave.cartHover", function (event) {
      isHoveringCartWidget = false;
      if (isDesktopCartHoverEnabled()) {
        if (isInCartInteractionArea(event.relatedTarget)) {
          clearCartCloseTimeout();
          return;
        }
        scheduleCartClose();
      }
    });
  });
}



document.addEventListener("ShoptetDOMSearchResultsLoaded", function(){
  $('.search-whisperer').append('<span class="close"></span>');
  
});
document.addEventListener('click', function (e) {
    const close = e.target.closest('.search-whisperer .close');

    if (!close) return;

    e.preventDefault();
    e.stopPropagation();

    const whisperer = close.closest('.search-whisperer');

    whisperer.classList.remove('active');
    whisperer.innerHTML = '';
}, true);

/*
$(document).on('click', '.search-whisperer .close, .searchWhisperer .close', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var $whisperer = $(this).closest('.search-whisperer, .searchWhisperer');

    $whisperer.removeClass('active').empty();
    $('body').removeClass('search-focused');

    return false;
});*/